// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'
import type { Point } from './google.map'
import _ from 'lodash'

const Input: StyledComponent<Object, any, any> = styled.input`
  width: 100%;
  height: 30px;
  padding: 5px;
`

type Props = {
  onSelect: (Point) => void
}

type State = {
  searchText: string
}

const t = {
  search_placeholder: 'Поиск на карте..'
}

export default class SearchBox extends Component<Props, State> {
  searchRef: any
  state = { searchText: '' }

  constructor(props: Props) {
    super(props)
    this.searchRef = React.createRef()
  }

  componentDidMount() {
    var input = this.searchRef.current
    var searchBox = new window.google.maps.places.SearchBox(input)

    // Listen for the event fired when the user selects a prediction and retrieve
    // more details for that place.
    searchBox.addListener('places_changed', () => {
      var places = searchBox.getPlaces()

      if (places.length === 0) {
        return
      }

      _.each(places, (place) => {
        const geometry = place.geometry
        if (!geometry) {
          console.log('Returned place contains no geometry')
          return
        }
        const radius =
          distanceInKmBetweenEarthCoordinates(...coordsFromGeometryBounds(place.geometry)) / 4
        this.props.onSelect({
          longitude: geometry.location.lng(),
          latitude: geometry.location.lat(),
          radius: radius,
          name: place.name
        })
        this.setState({ searchText: '' })
      })
    })
  }

  render() {
    return (
      <Input
        type="text"
        placeholder={t.search_placeholder}
        ref={this.searchRef}
        value={this.state.searchText}
        onChange={(e) => this.setState({ searchText: e.target.value })}
      />
    )
  }
}

function degreesToRadians(degrees) {
  return (degrees * Math.PI) / 180
}

function distanceInKmBetweenEarthCoordinates(lat1, lon1, lat2, lon2) {
  var earthRadiusKm = 6371

  var dLat = degreesToRadians(lat2 - lat1)
  var dLon = degreesToRadians(lon2 - lon1)

  lat1 = degreesToRadians(lat1)
  lat2 = degreesToRadians(lat2)

  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  return earthRadiusKm * c
}

function coordsFromGeometryBounds(geometry) {
  var bounds = new window.google.maps.LatLngBounds()
  if (geometry.viewport) {
    bounds.union(geometry.viewport)
  } else {
    bounds.extend(geometry.location)
  }
  var center = bounds.getCenter()
  var ne = bounds.getNorthEast()
  return [center.lat(), center.lng(), ne.lat(), ne.lng()]
}
